<template>
  <vs-popup
    class="add-new-company-address"
    id="popup"
    :title="isCreateMode ? 'ADD COMPANY ADDRESS' : ($can('edit-company-address-setting') ? 'UPDATE COMPANY ADDRESS' : 'VIEW COMPANY ADDRESS')"
    @close="open = false"
    :active.sync="open"
    :buttons-hidden="true"
  >
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="company-address-popup" @submit.prevent="handleSubmit(onClickSave)" autocomplete="off">
          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input
                  v-model="form.name"
                  name="name"
                  class="w-full"
                  :disabled="!$can('edit-company-address-setting')"
                  label=""
                  :danger="!!errors[0]"
                  :danger-text="errors[0]"
                  val-icon-danger="icon-x"
                  val-icon-pack="feather"
                />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-1/2 md:mb-0">
              <ValidationProvider vid="line1" name="line 1" rules="required" v-slot="{ errors }">
                <small class="label">Address Line 1</small>
                <vs-input
                  v-model="form.line1"
                  name="line1"
                  class="w-full"
                  :disabled="!$can('edit-company-address-setting')"
                  label=""
                  :danger="!!errors[0]"
                  :danger-text="errors[0]"
                  val-icon-danger="icon-x"
                  val-icon-pack="feather"
                />
              </ValidationProvider>
            </div>
            <div class="w-full vx-col md:w-1/2 md:mb-0">
              <ValidationProvider vid="line2" name="line 2" rules="" v-slot="{ errors }">
                <small class="label">Address Line 2</small>
                <vs-input
                  v-model="form.line2"
                  name="line2"
                  class="w-full"
                  :disabled="!$can('edit-company-address-setting')"
                  label=""
                  :danger="!!errors[0]"
                  :danger-text="errors[0]"
                  val-icon-danger="icon-x"
                  val-icon-pack="feather"
                />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="line3" name="line 3" rules="" v-slot="{ errors }">
                <small class="label">Address Line 3</small>
                <vs-input
                  v-model="form.line3"
                  name="line3"
                  class="w-full"
                  :disabled="!$can('edit-company-address-setting')"
                  label=""
                  :danger="!!errors[0]"
                  :danger-text="errors[0]"
                  val-icon-danger="icon-x"
                  val-icon-pack="feather"
                />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-1/2 md:mb-0">
              <ValidationProvider vid="town_state" name="town / state" rules="required" v-slot="{ errors }">
                <small class="label">Town / State</small>
                <vs-input
                  v-model="form.town_state"
                  name="town_state"
                  class="w-full"
                  :disabled="!$can('edit-company-address-setting')"
                  label=""
                  :danger="!!errors[0]"
                  :danger-text="errors[0]"
                  val-icon-danger="icon-x"
                  val-icon-pack="feather"
                />
              </ValidationProvider>
            </div>
            <div class="w-full vx-col md:w-1/2 md:mb-0">
              <ValidationProvider vid="post_code" name="post code" rules="required" v-slot="{ errors }">
                <small class="label">Postal Code</small>
                <vs-input
                  v-model="form.post_code"
                  name="post_code"
                  class="w-full"
                  :disabled="!$can('edit-company-address-setting')"
                  label=""
                  :danger="!!errors[0]"
                  :danger-text="errors[0]"
                  val-icon-danger="icon-x"
                  val-icon-pack="feather"
                />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                <small class="label">Country</small>
                <v-select
                  :filter-by="myFilter"
                  :clearable="false"
                  :disabled="!$can('edit-company-address-setting')"
                  name="country"
                  placeholder="Select Country"
                  label="name"
                  v-model="form.country"
                  :reduce="option => option.iso_code"
                  :options="countryCodes"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                >
                  <template v-slot:option="option">
                    <span>{{ option.name }} ({{ option.iso_code }})</span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-1/2 md:mb-0">
              <small class="label">Is Shipping Address?</small>
              <vs-switch
                v-model="form.is_shipping_address"
                :disabled="!$can('edit-company-address-setting')"
                icon-pack="feather"
                vs-icon-on="icon-check-circle"
                vs-icon-off="icon-slash"
                class="mt-2 w-16"
                @input="onShippingSwitchChange"
              >
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </div>
            <div class="w-full vx-col md:w-1/2 md:mb-0">
              <small class="label">Is Default Address?</small>
              <vs-switch
                v-model="form.is_default"
                :disabled="!$can('edit-company-address-setting')"
                icon-pack="feather"
                vs-icon-on="icon-check-circle"
                vs-icon-off="icon-slash"
                class="mt-2 w-16"
                @input="onDefaultSwitchChange"
              >
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                <small class="label">Note</small>
                <vs-textarea class="mb-0" :disabled="!$can('edit-company-address-setting')" v-model="form.note" height="100px" />
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div v-if="$can('edit-company-address-setting')" class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="onReset" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
          <div v-else class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="button" @click="open = false" class="mt-2 ml-auto" type="border" color="danger">Close</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
import vSelect from 'vue-select';
import SuccessMessage from '@/mixins/SuccessMessage';
import ErrorMessages from '@/mixins/ErrorMessages';

const CompanyAddressRepository = RepositoryFactory.get('company_address');
const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');

function initialState() {
  return {
    open: false,
    id: null,
    isCreateMode: true,
    countryCodes: [],
    form: {
      name: '',
      line1: '',
      line2: '',
      line3: '',
      town_state: '',
      post_code: '',
      country: '',
      type: 'company-address',
      is_shipping_address: false,
      is_default: false,
      note: ''
    }
  };
}

export default {
  name: 'AddNewCompanyAddressPopUp',
  props: {
    companyAddresses: {
      type: Array,
      default: () => []
    }
  },
  components: {
    'v-select': vSelect
  },
  mixins: [SuccessMessage, ErrorMessages],
  data() {
    return initialState();
  },
  methods: {
    async openPopup(id) {
      try {
        await Object.assign(this.$data, initialState());
        if (this.$refs.form) {
          this.$refs.form.reset();
        }
        this.open = true;
        await this.loadCountryCodes();
        if (id) {
          this.id = id;
          this.isCreateMode = false;
          await this.fetchAddressDetails();
        } else {
          this.isCreateMode = true;
        }
      } catch (error) {
        this.convertAndNotifyError(error);
      }
    },
    async loadCountryCodes() {
      try {
        const res = await SupplierManufactureRepository.getCountryCodes();
        this.countryCodes = (res.data && res.data.data) ? res.data.data : (res.data || []);
      } catch (e) {
        console.error('Failed to load country codes', e);
      }
    },
    async fetchAddressDetails() {
      await this.$vs.loading({
        container: '#company-address-popup',
        scale: 0.45
      });
      try {
        const res = await CompanyAddressRepository.getCompanyAddress(this.id);
        const data = (res.data && res.data.data) ? res.data.data : res.data;

        let countryVal = data.country || '';
        if (this.countryCodes && this.countryCodes.length) {
          const match = this.countryCodes.find(
            c => (c.name && c.name.toLowerCase() === (data.country || '').toLowerCase()) ||
                 (c.iso_code && c.iso_code.toLowerCase() === (data.country || '').toLowerCase())
          );
          if (match) {
            countryVal = match.iso_code;
          }
        }

        this.form = {
          name: data.name || '',
          line1: data.line1 || '',
          line2: data.line2 || '',
          line3: data.line3 || '',
          town_state: data.town_state || '',
          post_code: data.post_code || '',
          country: countryVal,
          type: 'company-address',
          is_shipping_address: !!data.is_shipping_address,
          is_default: !!data.is_default,
          note: data.note || ''
        };
      } catch (e) {
        this.convertAndNotifyError(e);
      } finally {
        this.$vs.loading.close('#company-address-popup > .con-vs-loading');
      }
    },
    getAddressesList() {
      if (this.companyAddresses && this.companyAddresses.length) {
        return this.companyAddresses;
      }
      if (this.$parent && this.$parent.company_addresses && this.$parent.company_addresses.length) {
        return this.$parent.company_addresses;
      }
      return [];
    },
    onDefaultSwitchChange(val) {
      if (!this.$can('edit-company-address-setting')) return;
      if (!this.isCreateMode && !val) {
        const list = this.getAddressesList();
        const otherDefaults = list.filter(
          item => String(item.id) !== String(this.id) && !!item.is_default
        );
        if (otherDefaults.length === 0) {
          this.form.is_default = true;
          this.$nextTick(() => {
            this.form.is_default = true;
          });
          this.showWarningMessage('At least one address must be set as default.');
        }
      }
    },
    onShippingSwitchChange(val) {
      if (!this.$can('edit-company-address-setting')) return;
      if (!this.isCreateMode && !val) {
        const list = this.getAddressesList();
        const otherShippings = list.filter(
          item => String(item.id) !== String(this.id) && !!item.is_shipping_address
        );
        if (otherShippings.length === 0) {
          this.form.is_shipping_address = true;
          this.$nextTick(() => {
            this.form.is_shipping_address = true;
          });
          this.showWarningMessage('At least one address must be set as shipping address.');
        }
      }
    },
    async onClickSave() {
      if (!this.$can('edit-company-address-setting')) return;
      if (!this.isCreateMode) {
        const list = this.getAddressesList();
        if (!this.form.is_default) {
          const otherDefaults = list.filter(
            item => String(item.id) !== String(this.id) && !!item.is_default
          );
          if (otherDefaults.length === 0) {
            this.form.is_default = true;
            this.showWarningMessage('At least one address must be set as default.');
            return;
          }
        }
        if (!this.form.is_shipping_address) {
          const otherShippings = list.filter(
            item => String(item.id) !== String(this.id) && !!item.is_shipping_address
          );
          if (otherShippings.length === 0) {
            this.form.is_shipping_address = true;
            this.showWarningMessage('At least one address must be set as shipping address.');
            return;
          }
        }
      }

      await this.$vs.loading({
        container: '#company-address-popup',
        scale: 0.45
      });
      try {
        const payload = {
          name: this.form.name,
          line1: this.form.line1,
          line2: this.form.line2 || '',
          line3: this.form.line3 || '',
          town_state: this.form.town_state,
          post_code: this.form.post_code,
          country: this.form.country,
          type: 'company-address',
          is_shipping_address: !!this.form.is_shipping_address,
          is_default: !!this.form.is_default,
          note: this.form.note || null
        };

        if (this.isCreateMode) {
          await CompanyAddressRepository.createCompanyAddress(payload);
          this.showSuccessMessage('Company address created successfully');
        } else {
          await CompanyAddressRepository.updateCompanyAddress(this.id, payload);
          this.showSuccessMessage('Company address updated successfully');
        }
        await this.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.convertAndNotifyError(e);
      } finally {
        this.$vs.loading.close('#company-address-popup > .con-vs-loading');
      }
    },
    async onReset() {
      if (!this.$can('edit-company-address-setting')) return;
      if (this.isCreateMode) {
        this.form = {
          name: '',
          line1: '',
          line2: '',
          line3: '',
          town_state: '',
          post_code: '',
          country: '',
          type: 'company-address',
          is_shipping_address: false,
          is_default: false,
          note: ''
        };
        if (this.$refs.form) {
          this.$refs.form.reset();
        }
      } else {
        await this.fetchAddressDetails();
      }
    },
    myFilter(option, label, search) {
      const query = (search || '').toLowerCase();
      const name = (option.name || '').toLowerCase();
      const code = (option.iso_code || '').toLowerCase();
      return name.includes(query) || code.includes(query);
    }
  }
};
</script>

<style scoped>
</style>
